module.exports = __webpack_public_path__ + "img/Plain credit card-pana 1.45dbbbb4.svg";